import { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router";
//import { OperationContext } from "../CreateOperation";
import { useStorageBagStore } from "../store/StorageStore";
import { ColumnItem } from "../../../common/models/table";
import { Loader } from "../../../common/components/Loader/Loader";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";
import { ActionsKey } from "../../../common/models/Actions";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { HttpStatusCode } from "axios";
import { ManifestoService } from "../../operations/core/_request";
import StorageBagDetail from "./forms/StorageBagDetail";
import CustomModal from "../../../common/components/Modal/CustomModal";
import CustomerRemovalForm from "./forms/CustomerRemovalForm";
import { StorageService } from "../core/_request";
import { AiOutlineFilePdf } from "react-icons/ai";
import { downloadPDF } from "../../../utilities/downloadPdf";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { CiInboxOut } from "react-icons/ci";

interface StorageBagListProps {
  storageType: string;
}

const StorageBagList = ({ storageType }: StorageBagListProps) => {
  // const { initialValue, refreshData } = useContext(OperationContext);

  const [isShowForm, setIsShowForm] = useState<boolean>(false);

  const {
    list: bagList,
    setList: setBagList,
    pageState,
    actioned,
    setActioned,
    setPageState,
    totalItems,
    resetPageState,
  } = useStorageBagStore();

  const { id } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [modalData, setModalData] = useState({});

  // const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const [downloadingId, setDownloadingId] = useState<string | null>(null);
  const idPdf = (bagList as any)[0]?.["@id"]?.split("/").pop();

  const cols: ColumnItem[] = [
    {
      key: "designation",
      title: "Désignation",
      dataIndex: "designation",
      show: true,
      // isCanSort: true,
    },

    {
      key: "batchNumber",
      title: "Numéro de Lot",
      dataIndex: "batchNumber",
      searchKey: "uniqueIdentifier",
      searchType: "text",
      show: true,
      // isCanSort: true,
    },
    {
      key: "content",
      title: "Contenu",
      dataIndex: "content",
      show: true,
      // isCanSort: true,
    },
    {
      key: "brand",
      title: "Marque",
      dataIndex: "brand",
      show: true,
      // isCanSort: true,
    },
    {
      key: "packaging",
      title: "Conditionnement",
      dataIndex: "packaging",
      show: true,
      // isCanSort: true,
    },
    {
      key: "",
      title: "Tonnage en stock (T)",
      dataIndex: "",
      show: true,
      render: (_: any, record: any) => {
        const storageLoads = record.storageLoadData || [];

        const matchingStorage = storageLoads.find((item: any) => {
          const storageId = item.storage?.["@id"]?.split("/").pop();
          return storageId === id;
        });

        return matchingStorage?.tonnageInStock || "-";
      },
    },
  ];

  const isFirstRender = useRef(true);
  const location = useLocation();

  useEffect(() => {
    isFirstRender.current = true; // chaque fois qu'on revient, on reset
  }, [location.pathname]);

  useEffect(() => {
    if (isFirstRender.current) {
      const { uniqueIdentifier, ...rest } = pageState;
      setPageState({
        ...rest,
        page: 1,
        itemsPerPage: 10,
        pagination: true,
      });
      isFirstRender.current = false;
    } else {
      fetchRequest(pageState);
    }
  }, [pageState]);

  const fetchRequest = (params?: any) => {
    // Remove uniqueIdentifier only on first render
    let cleanParams = params;
    if (isFirstRender.current) {
      const { uniqueIdentifier, ...rest } = params || {};
      cleanParams = rest;
    }
    getMovement("api/bag_loads", {
      ...cleanParams,
      "storageLoads.storage": id,
      "storageLoads.storageLoadState": ["IN", "RETURNED"],
    });
  };

  const getMovement = async (url: string, params: any) => {
    try {
      setIsLoading(true);

      const res = await ManifestoService.getAllMouvement(url, params);

      if (res?.status === HttpStatusCode.Ok) {
        setBagList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const onFinishAction = () => {
    setIsOpenModal(false);
    fetchRequest({ page: 1 });
    setPageState({
      ...pageState,
      page: 1,
    });
  };

  const handleOpenModal = () => {
    if (!isOpenModal) {
      getStorageLoad({
        ...pageState,
        storageLoadState: "IN",
        storage: id,
        uniqueIdentifierLoad: bagList[0]?.batchNumber,
      });
    }
    setIsOpenModal((prev: boolean) => !prev);
  };

  const getStorageLoad = async (params: any) => {
    try {
      setIsLoading(true);
      const res = await StorageService.getStorageLoadList(params);
      if (res.status === HttpStatusCode.Ok) setModalData(res?.data?.member[0]);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadClick = async (action: any) => {
    const rowData = action.row; // récupérer la vraie ligne
    try {
      const idPdf = rowData?.["@id"]
        ? rowData["@id"].split("/").pop()
        : rowData?.id;
      if (!idPdf) {
        console.error("Impossible de trouver l'ID pour cette ligne :", action);
        return;
      }
      const fileName = rowData?.batchNumber || "Rapport";
      setDownloadingId(idPdf);
      await downloadPDF(`/api/bag_loads/${idPdf}/EIR`, `${fileName}_EIR.pdf`);
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <div>
      <div>
        <Loader isLoading={isLoading} />
        <LFTableV3
          columns={cols}
          data={bagList}
          params={pageState}
          onAction={(record: any, actionType: ActionsKey) => {
            if (actionType === "read") {
              setActioned({ action: actionType, data: record });
              setIsShowForm(true);
            }
          }}
          isCanShow={() => true}
          onSearch={(search: any) => {
            setPageState(search);
          }}
          onSort={(sort: any) => {
            setPageState(sort);
          }}
          onResetSearch={() => {
            resetPageState();
          }}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
          onChangePage={(e: any) => setPageState(e)}
          otherActions={[
            /* (row) => (
              <div className="" onClick={handleOpenModal}>
                <CiInboxOut size={17} title="Enlèvement client" />
              </div>
            ), */
            (rowAction) => {
              const rowData = rowAction.row;
              const rowId = rowData?.["@id"]?.split("/").pop() || rowData?.id;
              return (
                <>
                { storageType === "OpenStorage" && (
                  <>
                  {(!rowData?.imported) ? (
                    <div>
                      {downloadingId === rowId ? (
                        <Spin
                          indicator={<LoadingOutlined spin />}
                          size="small"
                        />
                      ) : (
                        <AiOutlineFilePdf
                          title="Générer EIR"
                          onClick={() => handleDownloadClick(rowAction)}
                        />
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  </>                  
                )}
                </>
              );
            },
          ]}
        />
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={
            actioned?.action === "read"
              ? "Détails"
              : actioned?.action === "update"
              ? "Modification"
              : "Nouvau"
          }
          width={"75%"}
        >
          <StorageBagDetail
            {...{
              initialValue: actioned?.data,
              type: actioned?.action,
            }}
          />
        </CustomDrawer>
      ) : (
        ""
      )}

      {/* Modal section */}
      {isOpenModal && (
        <CustomModal
          isOpen={isOpenModal}
          hanldeCloseModal={handleOpenModal}
          title="Enlèvement client"
        >
          <CustomerRemovalForm
            onFinish={onFinishAction}
            initialValue={modalData}
            isBag
          />
        </CustomModal>
      )}
    </div>
  );
};

export default StorageBagList;
